import { render, staticRenderFns } from "./AccountSettingPaymentDetail.vue?vue&type=template&id=40c2721e&scoped=true"
import script from "./AccountSettingPaymentDetail.vue?vue&type=script&lang=js"
export * from "./AccountSettingPaymentDetail.vue?vue&type=script&lang=js"
import style0 from "./AccountSettingPaymentDetail.vue?vue&type=style&index=0&id=40c2721e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c2721e",
  null
  
)

export default component.exports